





































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import moment from 'moment';

import { IMaintenance } from '@/models';

import MaintenanceBanner from '@/components/maintenance/MaintenanceBanner.vue';

export default Vue.extend({
  name: 'SignInWizardView',

  components: { MaintenanceBanner },

  methods: {
    openPasswordStepIfRequested(shouldOpenPasswordStep: boolean) {
      const storedEmail = localStorage.getItem('user_name');
      if (!shouldOpenPasswordStep || !storedEmail) {
        return;
      }

      this.$nextTick(() => {
        const wizard = this.$refs.legacySignInWizard as
          | { step?: number; email?: string }
          | undefined;
        if (!wizard) {
          return;
        }
        // Intentionally skip the legacy email-validation step and open the password
        // step directly. This avoids leaking whether an email exists in the system;
        // invalid/unknown accounts are handled by the normal server-side login error.
        wizard.email = storedEmail;
        wizard.step = 2;
      });
    },

    clearPasswordStepQueryFlag() {
      if (
        !Object.prototype.hasOwnProperty.call(this.$route.query, 'passwordStep')
      ) {
        return;
      }

      const { passwordStep, ...queryWithoutFlag } = this.$route.query;
      void passwordStep;

      this.$router
        .replace({
          query: queryWithoutFlag
        })
        .catch(() => {
          // Ignore duplicated navigation errors.
        });
    }
  },

  computed: {
    provider(): any {
      return this.$altoleapAccounts.authProvider;
    },
    companyName(): any {
      return this.$altoleapAccounts.config.companyName;
    },
    logo(): any {
      return this.$altoleapAccounts.config.logo;
    },
    privacyRoute(): any {
      return this.$altoleapAccounts.routes.privacyRoute;
    },
    termsRoute(): any {
      return this.$altoleapAccounts.routes.termsRoute;
    },

    ...mapGetters({
      getNearestMaintenance: 'maintenance/getNearestMaintenance'
    }),

    maintenance(): IMaintenance | undefined {
      return this.getNearestMaintenance;
    },

    isCurrentlyUnderMaintenance(): boolean {
      if (!this.maintenance) {
        return false;
      }
      return moment(new Date()).isBetween(
        this.maintenance.start,
        this.maintenance.end,
        'second'
      );
    }
  },

  mounted() {
    const shouldOpenPasswordStep = this.$route.query.passwordStep === '1';
    this.openPasswordStepIfRequested(shouldOpenPasswordStep);
    this.clearPasswordStepQueryFlag();
  }
});
